import { gaTrackingCode } from '../config';
import {
  SALE,
  RENT,
  RENTDAILY
} from '../consts';

export function initialize (config) {
  if (gaTrackingCode && ga) {
    ga('create', gaTrackingCode, 'auto');
    ga('require', 'GTM-NM9NJGV');
    ga(function (tracker) {
      tracker.set({
        ...config,
        dimension10: tracker.get('clientId')
      });

      ga('send', 'pageview');
    });
  }
}

export function navigate (page) {
  if (gaTrackingCode && ga) {
    ga('set', 'page', page);
    ga('send', 'pageview');
  }
}

export function sendEvent (category, action, label, value) {
  if (gaTrackingCode && ga) {
    ga('send', {
      hitType: 'event',
      eventCategory: category,
      eventAction: action,
      eventLabel: label,
      eventValue: value
    });
  }
}

export function gtagReportConversion (url) {
  const callback = function () {
    if (typeof (url) !== 'undefined') {
      window.location = url;
    }
  };

  // eslint-disable-next-line
  gtag && gtag('event', 'conversion', {
    'send_to': 'AW-961809039/4Q_6CN650oYBEI-V0MoD',
    'transaction_id': '',
    'event_callback': callback
  });

  // @see http://jira.rn/browse/MLSN-624
  // eslint-disable-next-line
  gtag && gtag('event', 'conversion', {
    'send_to': 'AW-776667416/kzR9CJ2AppMBEJiCrPIC',
    'event_callback': callback
  });
  return false;
}

export function getCianObjectType (type, objectTypeId) {
  switch (type) {
    case 'apartments':
      if (objectTypeId === 101 || objectTypeId === 103 || objectTypeId === 104) {
        return 'suburban';
      }
      return 'flat_old,flat_new';
    case 'lands':
      return 'suburban';
    case 'commercials':
      return 'commercial';
    case 'garages':
      return 'commercial';
    default:
      return null;
  }
}

export function getUrlObjectType (type, objectTypeId) {
  switch (type) {
    case 'apartments':
      if (objectTypeId === 101 || objectTypeId === 103 || objectTypeId === 104) {
        return 'suburban';
      }
      return 'flat';
    case 'lands':
      return 'suburban';
    case 'commercials':
      return 'commercial';
    case 'garages':
      return 'commercial';
    default:
      return null;
  }
}

export function getExtraCategory (dealType, realtyType, objectType) {
  if (dealType === 'sale' && realtyType === 'apartments') {
    if (objectType === 0) {
      return 'roomSale';
    }
    if (objectType === 1 || objectType === 2 || objectType === 3 || objectType === 4 || objectType === 5) {
      return 'flatSale';
    }
    return 'flatSale';
  }
  if (dealType === 'sale' && realtyType === 'lands') {
    if (objectType === 36) {
      return 'countryHouseSale';
    }
    if (objectType === 101) {
      return 'houseSale';
    }
    if (objectType === 103) {
      return 'cottageSale';
    }
    if (objectType === 104) {
      return 'townhouseSale';
    }
    return 'landSale';
  }
  if (dealType === 'sale' && realtyType === 'commercials') {
    if (objectType === 35) {
      return 'landSale';
    }
    if (objectType === 37) {
      return 'officeSale';
    }
    if (objectType === 38) {
      return 'shoppingAreaSale';
    }
    if (objectType === 39) {
      return 'warehouseSale';
    }
    if (objectType === 42) {
      return 'businessSale';
    }
    if (objectType === 43) {
      return 'freeAppointmentObjectSale';
    }
    return 'officeSale';
  }
  if (dealType === 'sale' && realtyType === 'garages') {
    if (objectType === 311) {
      return 'metalGarageSale';
    }
    if (objectType === 264) {
      return 'capitalGarageSale';
    }
    if (objectType === 306) {
      return 'parkingSale';
    }
    return 'capitalGarageSale';
  }
  if (dealType === 'rent' && realtyType === 'apartments') {
    if (objectType === 0) {
      return 'roomRent';
    }
    if (objectType === 1 || objectType === 2 || objectType === 3 || objectType === 4 || objectType === 5) {
      return 'flatRent';
    }
    if (objectType === 101) {
      return 'houseRent';
    }
    if (objectType === 103) {
      return 'cottageRent';
    }
    if (objectType === 104) {
      return 'townhouseRent';
    }
    return 'flatRent';
  }
  if (dealType === 'rent' && realtyType === 'commercials') {
    if (objectType === 35) {
      return 'landRent';
    }
    if (objectType === 37) {
      return 'officeRent';
    }
    if (objectType === 38) {
      return 'shoppingAreaRent';
    }
    if (objectType === 39) {
      return 'warehouseRent';
    }
    if (objectType === 42) {
      return 'businessRent';
    }
    if (objectType === 43) {
      return 'freeAppointmentObjectRent';
    }
    return 'officeRent';
  }
  if (dealType === 'rentDaily' && realtyType === 'apartments') {
    if (objectType === 1 || objectType === 2 || objectType === 3 || objectType === 4 || objectType === 5) {
      return 'dailyFlatRent';
    }
    if (objectType === 101 || objectType === 103 || objectType === 104) {
      return 'dailyHouseRent';
    }
    return 'dailyFlatRent';
  }
  return null;
}

export function getCustomUrlCian (obj) {
  const dealType = obj.get('dealType').includes('rent');
  const dailyRentType = obj.get('dealType').includes('Daily');
  const realtyType = getUrlObjectType(obj.get('realtyType'), obj.get('objectTypeId'));
  return `/${dealType ? 'rent' : 'sale'}/${realtyType}/object_type=/spec=${obj.getIn(['author', 'isRealtor']) ? 'realtor' : 'none'}${dealType ? dailyRentType ? '/rent_type=daily/' : '/rent_type=long/' : '/'}${obj.get('id')}/from_developer=0/repres=0/owner=${obj.getIn(['author', 'userTypeId']) === 3 ? 1 : 0}`;
}

export function getCianDealType (dealType) {
  switch (dealType) {
    case SALE:
      return 'sale';
    case RENT:
      return 'rent_long';
    case RENTDAILY:
      return 'rent_day';
    default:
      return 'other';
  }
}

export function getParentId (property) {
  if (property.get('residentialComplex') && property.getIn(['residentialComplex', 'id'])) {
    return property.getIn(['residentialComplex', 'id']);
  }
  if (property.get('township') && property.getIn(['township', 'id'])) {
    return property.getIn(['township', 'id']);
  }
  return null;
}

export function gtagPushEventNewPage (options) {
  typeof window !== 'undefined' && window.dataLayer && window.dataLayer.push({ ...options });
}



// WEBPACK FOOTER //
// ./src/utils/googleAnalytics.js